import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ScrollToTop from "../../../../common/components/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import {
  formattedDateFromDB,
  formattedDateTimeFromDB,
} from "../../../../common/utils/FunctionsUtils";
import StickyCustomized from "../../../../common/components/StickyCustomized";
import PaperCustomized from "../../../../common/components/PaperCustomized";
import ButtonCustomized from "../../../../common/components/ButtonCustomized";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HistoryIcon from "@mui/icons-material/History";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {
  clearTiErrors,
  downloadTi,
  getTi,
  setIsDecisionTiVisible,
} from "../../state/TiActions";
import ListPaysProvenances from "../ListPaysProvenances";
import ListFactures from "../ListFactures";
import ListMarchandises from "../ListMarchandises";
import ListTracMinistere from "../ListTracMinistere";
import ListMarchandisesModified from "../ListMarchandisesModified";
import ListMarchandisesImputees from "../ListMarchandisesImputees";
import ListDocuments from "../ListDocuments";
import ListReglamentation from "../ListReglamentation";
import SuiviReglement from "../SuiviReglement";
import {
  CONSULTATION_TITRES_PAGE,
  GESTION_TITRES_PAGE,
  TITRE_HISTORIQUE_PAGE,
} from "../../../../common/constants/routerConstants";

export function BoldTypography({ label, value }) {
  return (
    <Typography>
      {label && (
        <Typography
          component="span"
          variant="inherit"
          sx={{ fontWeight: "bold" }}
        >
          {label} :{" "}
        </Typography>
      )}
      {value}
    </Typography>
  );
}

function TitreSuiviReglement(props) {
  const { id } = useParams();
  const location = useLocation();
  const [isDecision, setIsDecision] = useState(
    location.state?.isDecision || false
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const leReducer = useSelector((state) => state.leReducer);
  const tiReducer = useSelector((state) => state.tiReducer);
  const leDetail = leReducer?.licenceDetail;
  const tiDetail = tiReducer?.titreDetail;
  const [montantTotal, setMontantTotal] = useState(null);
  const tiDomiciliationBanque = tiDetail?.domiciliationBanque;
  const isLoading = tiReducer?.isLoading;
  const loading = isLoading;
  const [openFacture, setOpenFacture] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [severity, setSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const contentBottomRef = useRef(null);
  const success = tiReducer?.successMessage;
  const error = tiReducer?.error;
  const errore = tiReducer?.errore;
  const facturePDF = tiReducer?.factureDocumentPdf;
  const documentPdf = tiReducer?.documentPdf;
  const isDownloadLoading = tiReducer?.isDownloadLoading;
  const isDecisionLoading = tiReducer?.isDecisionLoading;
  const createBlobUrl = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/pdf",
    });
    return URL.createObjectURL(blob);
  };
  let chargedMerchandisesRows = [];
  leDetail?.merchandise?.forEach((mer) => {
    chargedMerchandisesRows.push(...mer.chargedMerchandises);
  });
  const titreReducer = useSelector((state) => state.titreReducer);

  const [isModeConsultation, setModeConsultation] = useState(
    titreReducer?.consultingMode
  );
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    setOpenFacture(false);
    setPdfData(null);
    dispatch(getTi(id, "REGL"));
  }, []);

  useEffect(() => {
    if (loading === false) {
      if (isDecision === true && contentBottomRef.current) {
        setTimeout(() => {
          contentBottomRef.current.scrollIntoView({ behavior: "smooth" });
        }, 0);
      } else if (isDecision === false) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    }
  }, [isDecision, loading]);

  const handleCloseFacture = () => {
    setOpenFacture(false);
    setPdfData(null);
  };

  const handleCloseDoc = () => {
    setOpenDoc(false);
    setPdfData(null);
  };

  useEffect(() => {
    if (facturePDF !== null && facturePDF !== "") {
      setPdfData(facturePDF);
      setOpenFacture(true);
    }
  }, [facturePDF]);

  useEffect(() => {
    if (documentPdf !== null && documentPdf !== "") {
      setPdfData(documentPdf);
      setOpenDoc(true);
    }
  }, [documentPdf]);

  useEffect(() => {
    let donneeReglamentationDtos = tiDetail.donneeReglamentationDtos;
    let sumQuantite = 0;
    if (donneeReglamentationDtos && donneeReglamentationDtos.length > 0) {
      sumQuantite = donneeReglamentationDtos.reduce((total, item) => {
        return total + item.quantite;
      }, 0);
    }
    setMontantTotal(
      tiDetail?.donneesTitreImportation?.montantTotal - sumQuantite
    );
  }, [tiDetail]);

  useEffect(() => {
    if (success !== null) {
      setAlertMessage(success);
      setShouldNavigate(true);
      setAlertOpen(true);
      setSeverity("success");
      if (isModeConsultation) {
        navigate(CONSULTATION_TITRES_PAGE);
      } else {
        navigate(GESTION_TITRES_PAGE);
      }
    } else if (error !== null) {
      setAlertMessage(error);
      setShouldNavigate(true);
      setAlertOpen(true);
      setSeverity("error");
    } else if (errore !== null) {
      setAlertMessage(errore);
      setAlertOpen(true);
      setSeverity("error");
    }
  }, [success, error, errore]);

  const handlePrintClick = () => {
    dispatch(downloadTi(id));
  };

  const handleHistoriqueClick = () => {
    navigate(TITRE_HISTORIQUE_PAGE + id);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (shouldNavigate === true) {
      if (isModeConsultation) {
        navigate(CONSULTATION_TITRES_PAGE);
      } else {
        navigate(GESTION_TITRES_PAGE);
      }
    }
    dispatch(clearTiErrors());
    setAlertOpen(false);
  };

  return (
    <Box>
      <Helmet>
        <title>{"Détails titre - Portail Banques"}</title>
      </Helmet>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Modal
            open={isDownloadLoading || isDecisionLoading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <CircularProgress />
          </Modal>
          <Modal open={openFacture} onClose={handleCloseFacture}>
            <Box
              style={{
                position: "absolute",
                top: "10%",
                left: "10%",
                right: "10%",
                bottom: "10%",
                backgroundColor: "white",
                padding: 20,
                overflow: "scroll",
              }}
            >
              {pdfData !== null && (
                <iframe
                  src={createBlobUrl(pdfData)}
                  style={{ width: "100%", height: "100%" }}
                  title="pdf"
                ></iframe>
              )}
            </Box>
          </Modal>
          <Modal open={openDoc} onClose={handleCloseDoc}>
            <Box
              style={{
                position: "absolute",
                top: "10%",
                left: "10%",
                right: "10%",
                bottom: "10%",
                backgroundColor: "white",
                padding: 20,
                overflow: "scroll",
              }}
            >
              {pdfData !== null && (
                <iframe
                  src={createBlobUrl(pdfData)}
                  style={{ width: "100%", height: "100%" }}
                  title="pdf"
                ></iframe>
              )}
            </Box>
          </Modal>
          <StickyCustomized>
            {!Boolean(props.isDecisionDomiciliation) && (
              <Box>
                <PaperCustomized forActions={true}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingRight: 1,
                    }}
                  >
                    <Box>
                      <ButtonCustomized
                        onClick={() => {
                          if (isModeConsultation) {
                            navigate(CONSULTATION_TITRES_PAGE);
                          } else {
                            navigate(GESTION_TITRES_PAGE);
                          }
                        }}
                        title="Retour"
                        startIcon={<ArrowBackIosIcon />}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: 1,
                        gap: 1,
                      }}
                    >
                      <Box>
                        <ButtonCustomized
                          title="Historique"
                          startIcon={<HistoryIcon />}
                          onClick={handleHistoriqueClick}
                        />
                      </Box>
                      <Box>
                        <ButtonCustomized
                          title="Imprimer"
                          startIcon={<LocalPrintshopIcon />}
                          onClick={handlePrintClick}
                        />
                      </Box>
                    </Box>
                  </Box>
                </PaperCustomized>
              </Box>
            )}
          </StickyCustomized>

          {tiDetail?.transitaire && (
            <Box sx={{ marginTop: "40px" }}>
              <PaperCustomized forActions={false} title="Declarant">
                <Box>
                  <Grid container spacing={1}>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Description"
                        value={tiDetail?.transitaire?.description}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Centre RC"
                        value={tiDetail?.transitaire?.centreRc}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="IFU"
                        value={tiDetail?.transitaire?.ifu}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Numero RC"
                        value={tiDetail?.transitaire?.numRc}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </PaperCustomized>
            </Box>
          )}

          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized forActions={false} title="Importateur">
              <Box>
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Description"
                      value={
                        tiDetail?.operateurImportateurExportateur?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="code PIN"
                      value={tiDetail?.operateurImportateurExportateur?.codePIN}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Centre RC"
                      value={
                        tiDetail?.operateurImportateurExportateur?.centreRc
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tax Professionnelle"
                      value={
                        tiDetail?.operateurImportateurExportateur?.tasaSocial
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="IFU"
                      value={tiDetail?.operateurImportateurExportateur?.ifu}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Numero RC"
                      value={
                        tiDetail?.operateurImportateurExportateur?.numeroRc
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Nº fichier DCE"
                      value={
                        tiDetail?.operateurImportateurExportateur?.numFicheroDCE
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Courrier électronique"
                      value={tiDetail?.operateurImportateurExportateur?.email}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Code postal"
                      value={tiDetail?.operateurImportateurExportateur?.email}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tèl mobile"
                      value={
                        tiDetail?.operateurImportateurExportateur?.telMobile
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tèl fixe"
                      value={tiDetail?.operateurImportateurExportateur?.telFixe}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Adresse"
                      value={
                        tiDetail?.operateurImportateurExportateur?.adresse2
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Localité"
                      value={
                        tiDetail?.operateurImportateurExportateur?.ville
                          ?.description
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </PaperCustomized>
          </Box>
          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized
              forActions={false}
              title="Données du Titre d'Importation"
            >
              <Box>
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="N° d'enregistrement"
                      value={
                        tiDetail?.donneesTitreImportation?.numEnregistrement
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Catégorie du titre"
                      value={
                        tiDetail?.donneesTitreImportation?.typeTitreImportation
                          ?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Etat"
                      value={
                        tiDetail?.donneesTitreImportation
                          ?.typeEtatTitreImportation?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="modalités paiement"
                      value={
                        tiDetail?.donneesTitreImportation?.modalitePaiement
                          ?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Devise"
                      value={
                        tiDetail?.donneesTitreImportation?.typeDevise?.code
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Montant total"
                      value={tiDetail?.donneesTitreImportation?.montantTotal}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Condition livraison"
                      value={
                        tiDetail?.donneesTitreImportation?.conditionLivraison
                          ?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Régime douanier"
                      value={
                        tiDetail?.donneesTitreImportation?.regimeDouanier
                          ?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Bureau douanier"
                      value={
                        tiDetail?.donneesTitreImportation?.bureauDouanier
                          ?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Expediteur"
                      value={tiDetail?.donneesTitreImportation?.expiditeur}
                    />
                  </Grid>
                </Grid>
              </Box>
            </PaperCustomized>
          </Box>
          {tiDomiciliationBanque && (
            <Box sx={{ marginTop: "40px" }}>
              <PaperCustomized
                forActions={false}
                title="Données relatives à la domiciliation"
              >
                <Box>
                  <Grid container spacing={1}>
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Nº de domiciliation"
                          value={tiDomiciliationBanque?.numTitreImportation}
                        />
                      </Grid>
                    ) : null}
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date d'acceptation"
                          value={formattedDateFromDB(
                            tiDomiciliationBanque?.dateDomiciliation
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant Total"
                        value={tiDomiciliationBanque?.montantTotal}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant FOB"
                        value={tiDomiciliationBanque?.quantiteFOB}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Assurance"
                        value={tiDomiciliationBanque?.assurance}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant FRET"
                        value={tiDomiciliationBanque?.quantiteCharge}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Accessoires"
                        value={tiDomiciliationBanque?.activites}
                      />
                    </Grid>
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date début de validité"
                          value={formattedDateTimeFromDB(
                            tiDomiciliationBanque?.dateDebutValiditee
                          )}
                        />
                      </Grid>
                    ) : null}
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date fin de validité"
                          value={formattedDateTimeFromDB(
                            tiDomiciliationBanque?.dateFinValiditee
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="RIB"
                        value={tiDomiciliationBanque?.tiCompteBanque?.numCompte}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Guichet"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.code
                        }
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Banque"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.banque?.description
                        }
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Code"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.banque?.code
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              </PaperCustomized>
            </Box>
          )}
          {tiDetail?.paysTitreImportation?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListPaysProvenances detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.arrTiFacturas?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListFactures
                detail={tiDetail}
                etat={tiDetail?.typeEtatTitreImportation?.description}
              />
            </Box>
          )}
          {tiDetail?.document?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListDocuments detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.modificacionMercancias && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandisesModified detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.arrTiMercancia?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandises
                detail={tiDetail}
                modified={tiDetail?.modificacionMercancias}
              />
            </Box>
          )}
          {tiDetail?.marchandisesImputes?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandisesImputees detail={tiDetail} />
            </Box>
          )}

          {tiDetail?.tracabiliteMinistere?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListTracMinistere detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.donneeReglamentationDtos &&
          tiDetail?.donneeReglamentationDtos.length > 0 ? (
            <Box sx={{ marginTop: "40px" }}>
              <ListReglamentation detail={tiDetail} />
            </Box>
          ) : null}
          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized forActions={false} title="Données du Règlement">
              <SuiviReglement
                id={id}
                montantTotal={montantTotal}
                devise={tiDetail?.donneesTitreImportation?.typeDevise}
                idDomiciliationBancaire={tiDomiciliationBanque?.id}
              />
            </PaperCustomized>
          </Box>
        </Box>
      )}
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
      <div ref={contentBottomRef}></div>
      <ScrollToTop />
    </Box>
  );
}

export default TitreSuiviReglement;
